import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=18f0ae20&scoped=true&"
import script from "./delivery-list.vue?vue&type=script&lang=js&"
export * from "./delivery-list.vue?vue&type=script&lang=js&"
import style0 from "./delivery-list.sass?vue&type=style&index=0&id=18f0ae20&scoped=true&lang=sass&"
import style1 from "./delivery-list.vue?vue&type=style&index=1&id=18f0ae20&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0ae20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/project/goeatbackup-con/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBadge,VBtn,VCard,VCardTitle,VContainer,VDialog,VFlex,VIcon,VLayout,VMenu,VProgressCircular,VSpacer})


/* vuetify-loader */
import installDirectives from "!G:/project/goeatbackup-con/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
